import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core'
import { list } from 'actions/data'
import { getContactsWithEmails } from 'actions/contacts'
import { listInbox } from 'actions/inbox'
import ConversationsList from './ConversationsList'
import ContactMobileView from './ContactMobileView'
import ContactSummary from './ContactSummary'
import SearchBox from './SearchBox'
import ThreadAndInput from './ThreadAndInput'
// import ConversationsListTabs from './ConversationsListTabs'

const styles = theme => ({
  conversationsListColumn: {
    backgroundColor: '#fff',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      flex: '0 0 25%',
      borderRight: '1px solid #7f7f7f',
    },
    zIndex: 1,
  },
  contactThreadColumn: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      flex: '2 0 0%',
      borderRight: '1px solid #7f7f7f',
    },
    height: '100%',
    backgroundColor: '#fff',
    position: 'relative',
  },
})

export default connect(
  state => ({
    threadViewVisible: state.inbox.threadViewVisible,
    conversationsListUserFilter: state.inbox.conversationsListUserFilter.filter,
    conversationsListFilter: state.inbox.conversationsListFilter,
  }),
  dispatch =>
    bindActionCreators(
      {
        list,
        getContactsWithEmails,
        listInbox,
      },
      dispatch,
    ),
)(
  withStyles(styles)(
    class InboxMobile extends Component {
      componentDidMount() {
        const {
          // list,
          getContactsWithEmails,
          listInbox,
          // conversationsListUserFilter,
        } = this.props

        getContactsWithEmails()

        listInbox({
          infiniteLoader: false,
          // endpoint: this.props.conversationsListFilter,
        })
      }

      render() {
        const { classes, location, threadViewVisible } = this.props
        return threadViewVisible ? (
          <div className={classes.contactThreadColumn}>
            <ContactSummary />
            <div style={{ display: 'none' }}>
              <ContactMobileView location={location} />
            </div>
            <ThreadAndInput />
          </div>
        ) : (
          <div className={classes.conversationsListColumn}>
            <SearchBox />
            {/* <ConversationsListTabs /> */}
            <ConversationsList />
          </div>
        )
      }
    },
  ),
)
